import React, { ReactElement } from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { getLayout } from 'components/layouts/Sidebar';
import { withAuth } from 'lib/hocs/withAuth';
import { HiringProvider } from 'lib/contexts/hiring-context';
import Hiring from './Hiring';

const HiringPage = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Hiring | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <HiringProvider>
        <Hiring />
      </HiringProvider>
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['hiring'])),
    },
  };
}

const HiringWrapper = withAuth(HiringPage);

// @ts-ignore
HiringWrapper.getLayout = getLayout;

export default HiringWrapper;
